//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    dark: Boolean,
  },
  data() {
    return {
      notVazio: [(v) => !!v || 'Campo obrigatório'],
      emailRules: [
        (v) => !!v || 'Preencha seu e-mail',
        (v) =>
          /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(v) ||
          'Digite um e-mail válido.',
      ],
      celularRules: [
        (v) => !!v || 'Preencha seu celular',
        (v) => (!!v && v.length > 10) || 'Digite um telefone válido.',
        (v) =>
          /\+?\(?\d{2,4}\)?[\d\s-]{9,}$/.test(v) ||
          'Digite um telefone válido.',
      ],
      sended: false,
      checkme: true,
      loading: false,
      maturidade: '',
    }
  },
  methods: {
    check() {
      let form = this.$refs['form' + this._uid]
      if (form) {
        this.checkme = !!form.$children.some((a) => a.hasError)
      }
    },
  },
  mounted() {
    new RDStationForms(
      'interesse-programa-de-incubacao-ii-2022-hub-e21-f0856b7602d9f733f366',
      'UA-228576147-1'
    ).createForm()
  },
}
